import React, { useEffect, useState } from 'react';
import './Authentication.scss';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { registerAction, verifyOtpAction, resetRegisterAction } from '../redux/auth/auth.actions';
import { toast } from 'react-toastify';
import { login } from '../firebase/googleLogin';
import { facebookLogin } from '../firebase/facebookLogin';

export default function SignUp() {
    const dispatch = useDispatch();
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState("");
    const [isShowConfirmPassword, setIsShowConfirmPassword] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { isLoading } = useSelector((state) => {
        return state.authInfo;
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleShowPassword = () => setIsShowPassword(!isShowPassword);
    const handleShowConfirmPassword = () => setIsShowConfirmPassword(!isShowConfirmPassword);
    const { registerData, errorMsg, isLoading: isRegisterLoading } = useSelector((state) => state.authInfo);

    // Reset registration state when component mounts if it's stale
    useEffect(() => {
        const storedRegisterData = localStorage.getItem('registerData');
        // If registerData exists in Redux but no stored data in localStorage, it's stale - reset it
        if (registerData?.status === 200 && !storedRegisterData) {
            dispatch(resetRegisterAction());
        }
    }, []);

    // Only navigate to verify-otp if we have fresh registration data (stored in localStorage)
    useEffect(() => {
        const storedRegisterData = localStorage.getItem('registerData');
        if (registerData?.status === 200 && storedRegisterData) {
            navigate("/auth/verify-otp");
        }
    }, [registerData, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
        setErrors((prevErrors) => ({ ...prevErrors, terms: '' }));
    };

    const validateForm = () => {
        const newErrors = {};
        const { name, email, password, confirmPassword } = formData;
        const isItalian = currentLanguage === "Italian";

        if (!name) {
            toast.error(isItalian ? 'Il nome è obbligatorio.' : 'Name is required.');
            return false;
        }
        if (!email) {
            toast.error(isItalian ? 'L\'email è obbligatoria.' : 'Email is required.');
            return false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            toast.error(isItalian ? 'Email non valida.' : 'Email is invalid.');
            return false;
        }
        if (!password) {
            toast.error(isItalian ? 'La password è obbligatoria.' : 'Password is required.');
            return false;
        }
        if (password.length < 6) {
            toast.error(isItalian ? 'La password deve contenere almeno 6 caratteri.' : 'Password must be at least 6 characters long.');
            return false;
        }
        if (!confirmPassword) {
            toast.error(isItalian ? 'La conferma della password è obbligatoria.' : 'Confirm Password is required.');
            return false;
        }
        if (password && confirmPassword && password !== confirmPassword) {
            toast.error(isItalian ? 'Le password non corrispondono.' : 'Passwords do not match.');
            return false;
        }
        if (!isChecked) {
            toast.error(isItalian ? 'Devi accettare i Termini e Condizioni.' : 'You must agree to the Terms and Conditions.');
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;

        setIsSubmitting(true);
        if (validateForm()) {
            try {
                localStorage.setItem("registerData", JSON.stringify(formData));
                await dispatch(registerAction(formData));
            }
            catch (error) {
                console.error("Error during registration:", error);
                const isItalian = currentLanguage === "Italian";
                toast.error(isItalian ? "Errore durante la registrazione. Riprova." : "Error during registration. Please try again.");
            }
        }
        setIsSubmitting(false);
    };

    useEffect(() => {
        const language = localStorage.getItem("language");
        setCurrentLanguage(language);
    }, []);

    const isItalian = currentLanguage === "Italian";

    return (
        <>
            <form onSubmit={handleSubmit} className='signup_wrapper'>
                <div className="top_text">
                    {isItalian ? "Registrati, Candidati per lavori" : "Let's register, let's vote"}
                </div>

                <div className="input_wrapper">
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder={isItalian ? 'Nome Completo*' : 'Full Name*'}
                    />
                </div>

                <div className="input_wrapper">
                    <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder={isItalian ? 'Email*' : 'Email*'}
                    />
                </div>

                <div className="input_wrapper passowrd mb20">
                    <input
                        type={isShowPassword ? 'text' : 'password'}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder={isItalian ? 'Password*' : 'Password*'}
                    />
                    <div className="pass_button" onClick={handleShowPassword}>
                        <img src={`${process.env.PUBLIC_URL}/images/${isShowPassword ? 'password_show' : 'password_hide'}.png`} alt="" />
                    </div>
                </div>

                <div className="input_wrapper passowrd mb20">
                    <input
                        type={isShowConfirmPassword ? 'text' : 'password'}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        placeholder={isItalian ? 'Conferma Password*' : 'Confirm Password*'}
                    />
                    <div className="pass_button" onClick={handleShowConfirmPassword}>
                        <img src={`${process.env.PUBLIC_URL}/images/${isShowConfirmPassword ? 'password_show' : 'password_hide'}.png`} alt="" />
                    </div>
                </div>

                <div className="term_condition">
                    <label htmlFor='terms'>
                        <input
                            type="checkbox"
                            name="terms"
                            id="terms"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                        <div className="tick"></div>
                        <div className="term_text">
                            {isItalian ? `Continuando, accetti i ` : `By continuing, you agree to the `}
                            <a href={`https://votiamo.com/terms/${isItalian ? "it" : ""}`} target="_blank" rel="noreferrer">
                                {isItalian ? "Termini di Servizio" : "Terms of Service"}
                            </a>
                            {isItalian ? " e la " : " and "}
                            <a href={`https://votiamo.com/privacy/${isItalian ? "it" : ""}`} target="_blank" rel="noreferrer">
                                {isItalian ? "Politica sulla Privacy" : "Privacy Policy"}
                            </a>.
                        </div>
                    </label>
                </div>

                <div className="action mb15">
                    <button type="submit" disabled={isLoading || isRegisterLoading || isSubmitting}>
                        {isSubmitting ? (
                            <>
                                <span className="loading-spinner"></span>
                                <span>{isItalian ? "Registrazione in corso..." : "Signing Up..."}</span>
                            </>
                        ) : isItalian ? 'Registrati' : 'Sign Up'}
                    </button>
                </div>

                <div className="or">{isItalian ? "Oppure" : "Or"}</div>

                <div className="login_option">
                    <button type="button" style={{ cursor: "pointer" }} onClick={e => login(dispatch, navigate)}>
                        <img src={`${process.env.PUBLIC_URL}/images/google.svg`} alt="" />
                    </button>
                    <button type="button" style={{ cursor: "pointer" }} onClick={e => facebookLogin()}>
                        <img src={`${process.env.PUBLIC_URL}/images/facebook.svg`} alt="" />
                    </button>
                </div>

                <div className="have_account">
                    {isItalian ? "Hai già un account? " : "Have an account? "}
                    <Link to="/auth">{isItalian ? "Accedi" : "Log In"}</Link>
                </div>
            </form>
        </>
    );
}
